import React from "react";
import {
    N8AO,
    EffectComposer,
    BrightnessContrast,
    FXAA,
    ToneMapping,
} from "@react-three/postprocessing";
import { BlendFunction } from "postprocessing";

type PostprocessingProps = {
    enabled: boolean;
};

export const Postprocessing: React.FC<PostprocessingProps> = ({ enabled }) => {
    return (
        <EffectComposer
            enabled={enabled}
            stencilBuffer
            enableNormalPass={false}
            autoClear={false}
            multisampling={0}
        >
            <FXAA />
            <ToneMapping
                blendFunction={BlendFunction.NORMAL}
                adaptive={true}
                resolution={256}
                middleGrey={2}
                maxLuminance={16.0}
                averageLuminance={1.0}
                adaptationRate={1.0}
            />
            <BrightnessContrast brightness={0.1} contrast={0.2} />
        </EffectComposer>
    );
};
